export default __webpack_public_path__ + "static/media/032-rover.e2114887.svg";